
export function split (str, symbol) {
    return str?str.split(symbol):[]
}

export function filterJSON(obj={}) {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([key, value]) => value !== null && value !== undefined)
    );
}